<div class="overflow-auto w-full h-full pb-20 space-y-4 text-left">
  <div>
    <h1 class="text-base font-extrabold text-slate-800">Member QR Tool</h1>
    <p class="text-sm text-slate-500 mt-1">
      Encode / Decode ตาม logic เดียวกับหน้าบัตรสมาชิก (ไม่ต้อง LIFF)
    </p>
  </div>

  <!-- Encode -->
  <section class="bg-white rounded-3xl border border-slate-100 shadow-sm p-4 space-y-3">
    <h2 class="text-sm font-extrabold text-slate-800 border-l-4 border-amber-500 pl-2">Encode</h2>

    <label class="block">
      <span class="text-sm font-bold text-slate-600">Card Code</span>
      <input type="text" [(ngModel)]="cardCode" (input)="encodePayload()" maxlength="64"
        inputmode="text"
        class="mt-1 w-full text-sm rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-200"
        placeholder="เช่น UUID / cardCode" />
    </label>

    <label class="block">
      <span class="text-sm font-bold text-slate-600">ทะเบียนรถ</span>
      <input type="text" [(ngModel)]="licensePlate" (input)="encodePayload()" maxlength="32"
        inputmode="text"
        class="mt-1 w-full text-sm rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-200"
        placeholder="เช่น กข 1234" />
    </label>

    <div *ngIf="encodedPayload" class="rounded-2xl bg-slate-900 text-amber-300 p-3 break-all">
      <p class="text-[10px] font-bold text-slate-400 mb-1">Payload (expire = now + 10 นาที)</p>
      <p class="text-sm font-mono leading-relaxed">{{ encodedPayload }}</p>
      <button type="button" (click)="copyEncoded()"
        class="mt-2 text-xs font-bold px-3 py-1.5 rounded-full bg-(--main-color) text-slate-900 border-none cursor-pointer">
        คัดลอก
      </button>
    </div>
  </section>

  <!-- Decode -->
  <section class="bg-white rounded-3xl border border-slate-100 shadow-sm p-4 space-y-3">
    <h2 class="text-sm font-extrabold text-slate-800 border-l-4 border-amber-500 pl-2">Decode</h2>

    <label class="block">
      <span class="text-sm font-bold text-slate-600">วาง QR payload</span>
      <textarea [(ngModel)]="decodeInput" (input)="decodePayload()" rows="3"
        class="mt-1 w-full text-sm rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-200 font-mono"
        placeholder="obfuscated$ทะเบียน"></textarea>
    </label>

    <p *ngIf="decodeError" class="text-sm text-rose-600 font-bold">{{ decodeError }}</p>

    <div *ngIf="decoded" class="rounded-2xl bg-emerald-50 border border-emerald-100 p-3 space-y-1.5 text-sm">
      <p><span class="text-slate-500 font-bold">cardCode:</span>
        <span class="font-mono font-extrabold text-slate-800 ml-1">{{ decoded.cardCode }}</span></p>
      <p><span class="text-slate-500 font-bold">expire (yyMMddHHmmss):</span>
        <span class="font-mono font-extrabold text-slate-800 ml-1">{{ decoded.expireYyMMddHHmmss }}</span></p>
      <p><span class="text-slate-500 font-bold">license:</span>
        <span class="font-mono font-extrabold text-slate-800 ml-1">{{ decoded.licensePlate }}</span></p>
    </div>
  </section>
</div>
